import { useMemo, useState } from 'react';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import {
  useDeleteProgramSet,
  useGetProgramSets,
} from '../../../redux/api/programsAPI';
import { Paths } from '../../../shared/paths';
import { orderBy } from '../../../utils/collections/array-utils';

export function useProgramSetsComponent() {
  const [programSetForDeleting, setProgramSetForDeleting] = useState(null);
  const {
    data: sets,
    isLoading,
    isUninitialized,
    error,
    refetch,
  } = useGetProgramSets();
  const [deleteProgramSet] = useDeleteProgramSet();
  const [filter, setFilter] = useState('');
  const { navigate } = useNavigationStack();

  const filteredSets = useMemo(
    () =>
      sets
        ? orderBy(
            sets?.filter(
              (program) => program.title.toLowerCase().indexOf(filter) !== -1,
            ),
            'title',
          )
        : null,
    [filter, sets],
  );

  function addNewProgramSetClicked() {
    //add restrictions
    navigate(Paths.programs.toNewSet);
  }

  return {
    filter,
    filteredSets: filteredSets ?? null,
    setFilter,
    programSetForDeleting,
    setProgramSetForDeleting,
    addNewProgramSetClicked,
    deleteProgramSet,
    isLoading: isLoading && !isUninitialized,
    error,
    hasData: Boolean(sets?.length),
    refetch,
  };
}
